import React from 'react';
import Header from '../component/Header';
import Footer from '../component/Footer';
import './styling/NotFoundPage.scss';

const NotFoundPage = () => {
  return (
    <div className="fullpage">
      <Header />
      <h1>Page Not Found</h1>
      <Footer className={"floor"} />
    </div>
  );
};

export default NotFoundPage;
